export enum PropertyType {
  Apartment = 'apartment',
  House = 'house',
}

export enum PropertyTypeValue {
  Apartment = 6,
  House = 5,
}

export enum KpiTypeValue {
  Price = 1,
  PricePerSquareMeter = 2,
  Rent = 3,
  RentPerSquareMeter = 4,
}

export type Culture = 'de-CH' | 'en-US' | 'fr-CH' | 'it-CH';

export enum LevelValue {
  Country = 1,
  Canton = 2,
  MSRegion = 3,
  Municipality = 5,
  Town = 6,
}

export type LevelIdValue = LevelValue | number | string;
